import styled from "@emotion/styled";
import { Chip } from "~/common/mui/Chip/Chip";
import type { CMSChipLinkProps } from "~/features/cms/components/cmsChip/CMSChipLink";
import { Avatar } from "~/common/mui";

const CMSChipLinkStandard = ({ chip, iconUrl, className, variant = "assist" }: CMSChipLinkProps) => {
  return (
    <StyledChip
      className={className}
      component={"a"}
      href={chip.navigationEntry.linkComponent.url}
      variant={variant}
      label={chip.title || chip.navigationEntry.linkComponent.name}
      {...(iconUrl && {
        avatar: <Avatar src={iconUrl} sx={{ borderRadius: 0 }} />,
      })}
    />
  );
};

const StyledChip = styled(Chip)({
  cursor: "pointer",
});

export default CMSChipLinkStandard;
